export default __webpack_public_path__ + "static/media/projects_management_icon.4bc6554a.png";